<div class="login-container">
  <div class="login-card">
    <h1 class="login-title">Proyecto Angular Base</h1>
    
    <form (ngSubmit)="login()" class="login-form" autocomplete="on">
      <div class="form-field">
        <label for="username" class="form-label">Usuario</label>
        <input
          type="text"
          id="username"
          [(ngModel)]="username"
          name="username"
          class="form-input"
          placeholder="Ingresa tu usuario"
          autocomplete="username"
          required
          aria-required="true"
        />
      </div>

      <div class="form-field">
        <label for="password" class="form-label">Contraseña</label>
        <input
          type="password"
          id="password"
          [(ngModel)]="password"
          name="password"
          class="form-input"
          placeholder="Ingresa tu contraseña"
          autocomplete="current-password"
          required
          aria-required="true"
        />
      </div>

      @if (errorMessage) {
        <div class="error-message" role="alert" aria-live="polite">
          {{ errorMessage }}
        </div>
      }

      <button type="submit" class="login-button">
        Ingresar
      </button>
    </form>
  </div>
</div>
